import BaseEntity from "@/core/misc/BaseEntity";
import Title_ru_RU from "@/core/misc/decorators/Title_ru_RU";
import TYPES from "@/core/services/Changelogs/types";
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

@Title_ru_RU_Class('Упаковка')
class Package extends BaseEntity {

  static Events = {
    Created: 'package:created',
    Updated: 'package:updated',
    Deleted: 'package:deleted',
  } as const;

  @Title_ru_RU('Название', TYPES.STRING)
  public name: string;

  @Title_ru_RU('Код', TYPES.STRING)
  public code: string;

  static fromServer(data: any, result = new Package()): Package {
    super.fromServer(data, result);

    return result;
  }

  toString(): string {
    return this.name;
  }
}

export default Package;
